import React, { Component } from 'react';
import PropTypes from 'prop-types';
import logo from '../../../assets/logos/haut.png';
import styles from './style.less';

export default class Logo extends Component {
  static propTypes = {
    min: PropTypes.bool,
  };
  static defaultProps = {
    logo: logo,
    title: 'React Web',
    min: false,
  };

  render() {
    const { min, title, ...others } = this.props;
    delete others.logo; // logo 属性不应透传到 DOM（否则会输出 logo="..." 非法属性）

    const temp = min ? styles.titleHide : null;
    return (
      <a href="/" className={styles.logo} title="返回官网首页">
        <img src={logo} alt="logo" />
        <h1 className={temp}>{title}</h1>
      </a>
    );
  }
}
